import Rellax from 'rellax';
import 'particles.js/particles';
const particlesJS = window.particlesJS;

export default class TopPageEvent {
  constructor() {
    this.init();
  }
  init() {
    // var rellax = new Rellax('.l_Rellax', {});

    particlesJS('particles-js', {
      particles: {
        number: {
          value: 20, //この数値を変更すると桜の数が増減できる
          density: {
            enable: true,
            value_area: 1121.6780303333778,
          },
        },
        color: {
          value: '#fff',
        },
        shape: {
          type: 'image',
          stroke: {
            width: 0,
          },
          image: {
            src: './assets/images/flower.png.webp',
            width: 100,
            height: 100,
          },
        },
        opacity: {
          value: 0.06409588744762158,
          random: true,
          anim: {
            enable: false,
            speed: 1,
            opacity_min: 0.1,
            sync: false,
          },
        },
        size: {
          value: 8.011985930952697,
          random: true, //サイズをランダムに
          anim: {
            enable: false,
            speed: 4,
            size_min: 0.1,
            sync: false,
          },
        },
        line_linked: {
          enable: false,
        },
        move: {
          enable: true,
          speed: 5, //この数値を小さくするとゆっくりな動きになる
          direction: 'bottom-left', //右下に向かって落ちる
          // random: false, //動きはランダムにしない
          straight: false, //動きをとどめない
          out_mode: 'out', //画面の外に出るように描写
          bounce: false, //跳ね返りなし
          attract: {
            enable: false,
            rotateX: 281.9177489524316,
            rotateY: 127.670995809726,
          },
        },
      },
      interactivity: {
        detect_on: 'canvas',
        events: {
          onhover: {
            enable: false,
          },
          onclick: {
            enable: false,
          },
          resize: true,
        },
      },
      retina_detect: false,
    });

    //
    const registerNMails = document.querySelectorAll('.js-registerNMail');
    const formModalWrap = document.querySelector('.p_formModalWrap');
    const formModalBg = document.querySelector('.p_formModalBg');
    const formModalCLose = document.querySelector('.p_formModalCLose');
    for (let i = 0; i < registerNMails.length; i++) {
      registerNMails[i].addEventListener('click', (e) => {
        e.preventDefault();
        formModalWrap.classList.add('Act');
      });
    }

    formModalBg.addEventListener('click', (e) => {
      formModalWrap.classList.remove('Act');
    });
    formModalCLose.addEventListener('click', (e) => {
      formModalWrap.classList.remove('Act');
    });

    //
    const CharaNavs = document.querySelectorAll('.js-CharaNav');
    const CharaPop = document.querySelector('.p_charaPopWrap');
    const CharaPopBg = document.querySelector('.p_charaPopBg');
    const CharaPopBox = document.querySelector(' .p_charaPopBox');
    const CharaPopClose = document.querySelector('.p_charaPopBoxClose');
    const CharaOnes = document.querySelectorAll('.js-CharaOne');
    let Chara = '';
    let CharaBool = true;

    for (let i = 0; i < CharaNavs.length; i++) {
      CharaNavs[i].addEventListener('click', (e) => {
        const type = e.currentTarget.dataset.type;
        CharaBool = false;
        setTimeout(() => {
          CharaBool = true;
        }, 500);
        document.getElementsByClassName('TopPageCharacters Act')[0].classList.remove('Act');
        document.getElementsByClassName('TopPageCharacters ' + type)[0].classList.add('Act');
        document.getElementsByClassName('TopPageCharacterNavOne Act')[0].classList.remove('Act');
        e.currentTarget.classList.add('Act');
      });
    }

    for (let i = 0; i < CharaOnes.length; i++) {
      CharaOnes[i].addEventListener('click', (e) => {
        if (!CharaBool) {
          return false;
        }
        const type = e.currentTarget.dataset.chara;
        if (Chara) {
          CharaPopBox.classList.remove(Chara);
        }
        CharaPop.classList.add('Act');
        CharaPopBox.classList.add(type);
        Chara = type;
        if (document.getElementsByClassName('p_charaPopCharaImage Act').length > 0) {
          document.getElementsByClassName('p_charaPopCharaImage Act')[0].classList.remove('Act');
        }
        document.querySelectorAll('[data-charaImage="' + type + '"]')[0].classList.add('Act');
      });
    }
    CharaPopBg.addEventListener('click', (e) => {
      resetVoice();
      CharaPop.classList.remove('Act');
    });
    CharaPopClose.addEventListener('click', (e) => {
      resetVoice();
      CharaPop.classList.remove('Act');
    });
    let audioAction = null;
    const Voice1 = document.querySelector('.js-Voice1');
    Voice1.addEventListener('click', (e) => {
      resetVoice();
      audioAction = document.querySelector(`audio[data-voiceKey="${Chara}-1"]`);
      audioAction.play();
    });
    const Voice2 = document.querySelector('.js-Voice2');
    Voice2.addEventListener('click', (e) => {
      resetVoice();
      audioAction = document.querySelector(`audio[data-voiceKey="${Chara}-2"]`);
      audioAction.play();
    });
    const Voice3 = document.querySelector('.js-Voice3');
    Voice3.addEventListener('click', (e) => {
      resetVoice();
      audioAction = document.querySelector(`audio[data-voiceKey="${Chara}-3"]`);
      audioAction.play();
    });

    const SPVoice1s = document.querySelectorAll('.TopPageCharactersPanelSoundsVoice1');
    for (let i = 0; i < SPVoice1s.length; i++) {
      SPVoice1s[i].addEventListener('click', (e) => {
        // console.log(e.currentTarget.dataset.voicesp);
        resetVoice();
        audioAction = document.querySelector(
          `audio[data-voiceKey="${e.currentTarget.dataset.voicesp}-1"]`
        );
        audioAction.play();
      });
    }

    const SPVoice2s = document.querySelectorAll('.TopPageCharactersPanelSoundsVoice2');
    for (let i = 0; i < SPVoice2s.length; i++) {
      SPVoice2s[i].addEventListener('click', (e) => {
        resetVoice();
        audioAction = document.querySelector(
          `audio[data-voiceKey="${e.currentTarget.dataset.voicesp}-2"]`
        );
        audioAction.play();
      });
    }

    const SPVoice3s = document.querySelectorAll('.TopPageCharactersPanelSoundsVoice3');
    for (let i = 0; i < SPVoice3s.length; i++) {
      SPVoice3s[i].addEventListener('click', (e) => {
        resetVoice();
        audioAction = document.querySelector(
          `audio[data-voiceKey="${e.currentTarget.dataset.voicesp}-3"]`
        );
        audioAction.play();
      });
    }

    function resetVoice() {
      if (audioAction) {
        audioAction.pause();
        audioAction.currentTime = 0;
        audioAction = null;
      }
    }

    //
    const CharaSPOnes = document.querySelectorAll('.js-CharaSPOne');
    for (let i = 0; i < CharaSPOnes.length; i++) {
      CharaSPOnes[i].addEventListener('click', (e) => {
        const type = e.currentTarget.dataset.chara;
        changeSPOne(type, e.currentTarget);
        // if (document.getElementsByClassName('TopPageCharactersPanel Act').length > 0) {
        //   document.getElementsByClassName('TopPageCharactersPanel Act')[0].classList.remove('Act');
        // }
        // document.querySelectorAll('[data-charaSP="' + type + '"]')[0].classList.add('Act');

        // document.getElementsByClassName('js-CharaSPOne Act')[0].classList.remove('Act');
        // e.currentTarget.classList.add('Act');
      });
    }

    function changeSPOne(type, target) {
      if (document.getElementsByClassName('TopPageCharactersPanel Act').length > 0) {
        document.getElementsByClassName('TopPageCharactersPanel Act')[0].classList.remove('Act');
      }
      document.querySelectorAll('[data-charaSP="' + type + '"]')[0].classList.add('Act');
      document.getElementsByClassName('js-CharaSPOne Act')[0].classList.remove('Act');
      target.classList.add('Act');
    }

    // aya
    // kanon
    // rin
    // oto
    const CharaSeasons = document.querySelectorAll('.TopPageCharactersNavSeasonOne');
    for (let i = 0; i < CharaSeasons.length; i++) {
      CharaSeasons[i].addEventListener('click', (e) => {
        const type = e.currentTarget.dataset.type;

        if (type == 'Winter') {
          changeSPOne(
            'kokone',
            document.querySelectorAll('.js-CharaSPOne[data-chara="kokone"]')[0]
          );
        }
        if (type == 'Summer') {
          changeSPOne('rin', document.querySelectorAll('.js-CharaSPOne[data-chara="rin"]')[0]);
        }
        if (type == 'Spring') {
          changeSPOne('oto', document.querySelectorAll('.js-CharaSPOne[data-chara="oto"]')[0]);
        }
        if (type == 'Autumn') {
          changeSPOne('kanon', document.querySelectorAll('.js-CharaSPOne[data-chara="kanon"]')[0]);
        }

        document
          .getElementsByClassName('TopPageCharactersNavIconList Act')[0]
          .classList.remove('Act');
        document
          .getElementsByClassName('TopPageCharactersNavIconList ' + type)[0]
          .classList.add('Act');
        document
          .getElementsByClassName('TopPageCharactersNavSeasonOne Act')[0]
          .classList.remove('Act');
        e.currentTarget.classList.add('Act');
      });
    }

    //
    const youtubePop = document.querySelector('.p_youtubePopWrap');
    const youtubePopBG = document.querySelector('.p_youtubePopBg');
    const youtubePopClose = document.querySelector('.p_youtubePopClose');
    const youtubePopBox = document.querySelector('.p_youtubePopBox');
    const youtubePopBoxInner = document.querySelector('.p_youtubePopBoxInner');
    const movieSlides = document.querySelectorAll('.js-movieSlide');

    for (let i = 0; i < movieSlides.length; i++) {
      movieSlides[i].addEventListener('click', (e) => {
        const youtube = e.currentTarget.dataset.youtube;
        youtubePop.classList.add('Act');

        youtubePopBoxInner.innerHTML =
          ' <iframe width="560" height="315" src="https://www.youtube.com/embed/' +
          youtube +
          '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
      });
    }
    youtubePopBG.addEventListener('click', (e) => {
      youtubePop.classList.remove('Act');
      youtubePopBoxInner.innerHTML = '';
    });
    youtubePopClose.addEventListener('click', (e) => {
      youtubePop.classList.remove('Act');
      youtubePopBoxInner.innerHTML = '';
    });

    ///
    const CharArr = [
      'aya',
      'kokone',
      'natsuume',
      'mari',
      'kanon',
      'sakuno',
      'kou',
      'rin',
      'shirara',
      'arie',
      'oto',
      'mimi',
      'ranko',
    ];
    const footChara = document.querySelector('.p_footerCharaOne');
    let get = CharArr[Math.floor(Math.random() * CharArr.length)];

    footChara.innerHTML =
      '<img src="./assets/images/chara_' + get + '.png.webp", alt="" class="m_image">';
    ///

    const Toggle = document.querySelector('.p_headerToggle');
    const Banner = document.querySelector('.p_stickBanner');

    const observerChara = new IntersectionObserver(
      (entries) => {
        // entriesは監視対象すべてが入っているリスト
        for (const e of entries) {
          // isIntersecting プロパティは交差しているかどうかの真偽値
          // viewport に交差し、入ったときに isIntersecting === true、出たときに false になる
          if (e.isIntersecting) {
            Banner.classList.add('SPView');
            // console.log(e);
          } else {
            Banner.classList.remove('SPView');
            // console.log(e);
          }
        }
      },
      {
        root: null, //ターゲットが見えるかどうかを確認するためのビューポート, nullはブラウザビューポート
        rootMargin: '0% 0% 0% 0%', //rootの周りのマージンの値
        threshold: 0.5, //どの程度表示されたか
      }
    );
    observerChara.observe(document.querySelector('.TopPageCharacter'));

    const observer = new IntersectionObserver(
      (entries) => {
        // entriesは監視対象すべてが入っているリスト
        for (const e of entries) {
          // isIntersecting プロパティは交差しているかどうかの真偽値
          // viewport に交差し、入ったときに isIntersecting === true、出たときに false になる
          if (e.isIntersecting) {
            Toggle.classList.remove('View');
            Banner.classList.remove('View');
            // console.log(e);
          } else {
            Toggle.classList.add('View');
            Banner.classList.add('View');
            // console.log(e);
          }
        }
      },
      {
        root: null, //ターゲットが見えるかどうかを確認するためのビューポート, nullはブラウザビューポート
        rootMargin: '0% 0% 0% 0%', //rootの周りのマージンの値
        threshold: 0.5, //どの程度表示されたか
      }
    );
    observer.observe(document.querySelector('.TopPageKV'));
  }
}
